import { createContext, useContext } from "react";

export type PanelVariant = "frosted" | "flat";

const PanelVariantContext = createContext<PanelVariant>("flat");

export const PanelVariantProvider = PanelVariantContext.Provider;
export function usePanelVariant() {
  return useContext(PanelVariantContext);
}

export default PanelVariantContext;
